/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { PostProcessingStatusEnum } from "./PostProcessingStatusEnum";
import {
  PostProcessingStatusEnumFromJSON,
  PostProcessingStatusEnumFromJSONTyped,
  PostProcessingStatusEnumToJSON,
  PostProcessingStatusEnumToJSONTyped,
} from "./PostProcessingStatusEnum";

/**
 * Serialize all simulations that still need to be post-processed by
 * Lizard (post-processing status is 'requested').
 * @export
 * @interface PostProcessingQueue
 */
export interface PostProcessingQueue {
  /**
   *
   */
  simulation: number;
  /**
   *
   */
  status: PostProcessingStatusEnum;
  /**
   *
   */
  readonly created?: Date;
}

/**
 * Check if a given object implements the PostProcessingQueue interface.
 */
export function instanceOfPostProcessingQueue(value: object): value is PostProcessingQueue {
  if (!("simulation" in value) || value["simulation"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function PostProcessingQueueFromJSON(json: any): PostProcessingQueue {
  return PostProcessingQueueFromJSONTyped(json, false);
}

export function PostProcessingQueueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostProcessingQueue {
  if (json == null) {
    return json;
  }
  return {
    simulation: json["simulation"],
    status: PostProcessingStatusEnumFromJSON(json["status"]),
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
  };
}

export function PostProcessingQueueToJSON(json: any): PostProcessingQueue {
  return PostProcessingQueueToJSONTyped(json, false);
}

export function PostProcessingQueueToJSONTyped(
  value?: Omit<PostProcessingQueue, "created"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    simulation: value["simulation"],
    status: PostProcessingStatusEnumToJSON(value["status"]),
  };
}
